import { render, staticRenderFns } from "./RegisterComplete.vue?vue&type=template&id=2106b0ba&scoped=true&"
import script from "./RegisterComplete.vue?vue&type=script&lang=js&"
export * from "./RegisterComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2106b0ba",
  null
  
)

export default component.exports